"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNotEmpty = exports.padStart = exports.padEnd = void 0;
exports.padEnd = function (str, length, fill) {
    if (fill === void 0) { fill = " "; }
    if (str.length >= length)
        return str.slice(0, length);
    return str.padEnd(length, fill);
};
exports.padStart = function (str, size, fill) {
    if (fill === void 0) { fill = " "; }
    if (str.length >= size)
        return str.slice(str.length - size, str.length);
    return str.padStart(size, fill);
};
exports.isNotEmpty = function (str) {
    if (str === undefined)
        return false;
    if (str === null)
        return false;
    return str !== "";
};
//# sourceMappingURL=string.js.map